import React, { createContext, useContext, useState, useCallback } from "react";

const Ctx = createContext(null);

export function UiModeProvider({ children }) {
  const [lite, setLiteState] = useState(() => {
    try { return localStorage.getItem("portal_lite") === "1"; } catch { return false; }
  });
  const [showCommunity, setShowCommunityState] = useState(() => {
    try { return localStorage.getItem("show_community") !== "0"; } catch { return true; }
  });
  const setLite = useCallback((v) => {
    setLiteState(v);
    try { localStorage.setItem("portal_lite", v ? "1" : "0"); } catch { /* private mode */ }
  }, []);
  const setShowCommunity = useCallback((v) => {
    setShowCommunityState(v);
    try { localStorage.setItem("show_community", v ? "1" : "0"); } catch { /* private mode */ }
  }, []);
  return <Ctx.Provider value={{ lite, setLite, showCommunity, setShowCommunity }}>{children}</Ctx.Provider>;
}

export const useUiMode = () =>
  useContext(Ctx) || { lite: false, setLite: () => {}, showCommunity: true, setShowCommunity: () => {} };
